'use client';

import { CreationGlassSurface } from './CreationGlassSurface';
import styles from './CreationChrome.module.css';

/** Decorative lens keeps the floating surface's native DOM, focus target and refs intact. */
export function CreationGlassBackdrop() {
  return <div aria-hidden="true" className={styles.backdrop}>
    <CreationGlassSurface className={styles.lens}>{null}</CreationGlassSurface>
  </div>;
}
